export const SUPPORTED_ANDROID_VERSIONS = [7, 8, 9, 10];
export const SUPPORTED_IOS_VERSIONS = [10, 11, 12, 13, 14];
